import { render, staticRenderFns } from "./createNew.vue?vue&type=template&id=6969f52a&"
import script from "./createNew.vue?vue&type=script&lang=ts&"
export * from "./createNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports